import { useTranslation } from 'react-i18next';

const categoryImages = [
  {
    name: 'Shoes',
    url: 'https://readdy.ai/api/search-image?query=Luxury%20designer%20sneakers%20on%20dark%20textured%20surface%2C%20dramatic%20warm%20lighting%2C%20premium%20fashion%20product%20photography%2C%20rich%20contrast%2C%20editorial%20luxury%20aesthetic%2C%20visible%20stitching%20and%20leather%20textures&width=400&height=300&seq=about-shoes-v2&orientation=landscape',
  },
  {
    name: 'Hoodies/Sweaters',
    url: 'https://readdy.ai/api/search-image?query=Oversized%20cozy%20hoodie%20on%20vintage%20wooden%20chair%20in%20sunlit%20room%2C%20warm%20amber%20tones%2C%20lifestyle%20fashion%20photography%2C%20artistic%20composition%20with%20fabric%20folds%2C%20bohemian%20aesthetic&width=400&height=300&seq=about-hoodies-v2&orientation=landscape',
  },
  {
    name: 'T-Shirts',
    url: 'https://readdy.ai/api/search-image?query=Premium%20cotton%20t-shirt%20on%20rough%20concrete%20surface%2C%20urban%20industrial%20setting%2C%20muted%20earth%20tones%2C%20contemporary%20streetwear%20photography%2C%20textured%20fabric%20details%2C%20authentic%20aesthetic&width=400&height=300&seq=about-tshirts-v2&orientation=landscape',
  },
  {
    name: 'Jackets',
    url: 'https://readdy.ai/api/search-image?query=Premium%20leather%20jacket%20on%20exposed%20brick%20wall%2C%20dramatic%20shadows%2C%20rich%20tobacco%20tones%2C%20moody%20editorial%20fashion%20photography%2C%20visible%20leather%20grain%20texture%2C%20sophisticated%20urban%20atmosphere&width=400&height=300&seq=about-jackets-v2&orientation=landscape',
  },
];

export default function AboutSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full bg-accent-50 py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-14">
          <span className="inline-block bg-background-50 text-foreground-700 text-sm font-medium px-5 py-2 rounded-full mb-5">
            {t('about.label')}
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 leading-tight">
            {t('about.title1')}<br />
            {t('about.title2')}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 md:gap-8 mb-14">
          {categoryImages.map((cat, i) => (
            <div key={i} className="group cursor-pointer">
              <div className="aspect-[4/3] rounded-xl overflow-hidden mb-4">
                <img
                  src={cat.url}
                  alt={cat.name}
                  title={`${cat.name} - Kakobuy Spreadsheet`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <p className="text-foreground-600 text-sm leading-relaxed">
                <strong className="text-foreground-900">{cat.name}</strong> – odkryj najpopularniejsze produkty w tej kategorii dzięki naszemu Kakobuy Spreadsheet. Każda kategoria zawiera starannie wyselekcjonowane pozycje z wysokimi ocenami i sprawdzonymi opiniami.
              </p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {[
            { num: '2000+', label: t('about.stat1Label') },
            { num: '14', label: t('about.stat2Label') },
            { num: '2026', label: t('about.stat3Label') },
            { num: '🇵🇱', label: t('about.stat4Label') },
          ].map((stat, i) => (
            <div key={i} className="text-center">
              <div className="font-heading text-3xl md:text-5xl font-bold text-accent-600 mb-2">
                {stat.num}
              </div>
              <div className="text-sm text-foreground-500">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}